import { ContextConsumer, type Context, type ContextType } from '@lit/context';
import type { ReactiveController, ReactiveControllerHost } from 'lit';

import { createChangeFilter } from './change-filter.js';

// Skips the first value, like the pub/sub listeners it replaces, which subscribed after an explicit first call.
export class ContextChangeController<C extends Context<unknown, unknown>> implements ReactiveController {
  private readonly __filter = createChangeFilter<ContextType<C>>();

  constructor(
    host: ReactiveControllerHost & HTMLElement,
    context: C,
    onChange: (value: NonNullable<ContextType<C>>) => void,
  ) {
    host.addController(this);
    new ContextConsumer(host, {
      context,
      subscribe: true,
      callback: (value) => {
        if (this.__filter.accept(value)) onChange(value as NonNullable<ContextType<C>>);
      },
    });
  }

  hostDisconnected() {
    this.__filter.reset();
  }
}
